import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LogData } from 'src/app/shared/models/logdata';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { resetData } from 'src/app/shared/models/resetModel';

@Injectable({
  providedIn: 'root',
})
export class resetService {
  baseUrl: string = environment.cloudUrl;
  resetUrl: string = this.baseUrl + 'password/reset/firstTimelogin';
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router
  ) {}

  changeOldPassword(data: resetData): Observable<any> {
    const url = this.resetUrl;
    return this.http.post<resetData>(url, data).pipe(
      map((data) => {
        return data;
      }),
      catchError(this.handleError)
    );
  }
  handleError(error) {
    let errorMessage = '';
    if (
      error.error instanceof ErrorEvent ||
      error.status == 404 ||
      error.status == 401
    ) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = error.statusText;
    }
    return throwError(errorMessage);
  }
}
